export default __webpack_public_path__ + "static/aap-red-fr~KGEJzWPI-ab7be50e747d858512331431781d2d7b.png";